import { all, takeEvery, put, call, select } from "redux-saga/effects";
import actions from "./actions";
import * as services from "./services";

const getProfileState = (state) => state.profile;

export function* AUTH_USER({ payload }) {
  const { userName, password } = payload;
  const response = yield call(services.authUser, userName, password);
  if (response) {
    yield put({
      type: actions.GET_CURRENT_USER,
      payload: { id: response.id },
    });
  }

}

export function* DEAUTH_USER({ payload }) {
  yield call(services.signOut);
  yield put({
      type: actions.GET_CURRENT_USER,
      payload: { uid: null },
    });
}

export function* REG_USER({ payload }) {
  const { userName, password, email } = payload;
  const response = yield call(services.registerUser, userName, password, email);
  if (response) {
    yield put({
      type: actions.GET_CURRENT_USER,
      payload: { id: response.uid },
    });
  }
}

export function* GET_CURRENT_USER({ payload }) {
  const { uid } = payload;
  const response = yield call(services.getCurrentUser, uid);
  const creditzIds = yield call(services.getCreditzLength, uid);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentUser: { ...response },
        creditzIds: creditzIds,
        authenticated: true,
        globalLoading: false,
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentUser: {},
        authenticated: false,
        globalLoading: false,
      },
    });
  }
}

export function* GET_USER_MUSICS() {
  const { creditzIds = [] } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  const creditz = [];
  if (creditzIds.length === 0) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
    return;
  }
  for (let i = 0; i < creditzIds.length; i++) {
    const response = yield call(services.getUserMusics, creditzIds[i]);
    creditz.push(response);
  }
  if (creditz) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        creditz,
        loading: false,
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
  }
}

export function* UPDATE_USER_STATUS({ payload }) {
  const { currentUser } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  const response = yield call(services.updateUserStatus, currentUser);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentUser,
        loading: false,
      },
    });
  } else {
    // TODO: remove current user from here
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentUser,
        loading: false,
      },
    });
  }
}

export function* GET_ALL_ACHIEVEMENTS() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  const { currentUser } = yield select(getProfileState);
  const response = yield call(services.getAllAchievements, currentUser.uid);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        achievements: response,
        loading: false,
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.AUTH_USER, AUTH_USER),
    takeEvery(actions.DEAUTH_USER, DEAUTH_USER),
    takeEvery(actions.REG_USER, REG_USER),
    takeEvery(actions.GET_CURRENT_USER, GET_CURRENT_USER),
    takeEvery(actions.GET_USER_MUSICS, GET_USER_MUSICS),
    takeEvery(actions.UPDATE_USER_STATUS, UPDATE_USER_STATUS),
    takeEvery(actions.GET_ALL_ACHIEVEMENTS, GET_ALL_ACHIEVEMENTS),
  ]);
}
